import { Link } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import AmktCommonPropTypes from '../../../../../app/constants/PropTypes';
import LargeHeaderContent from './LargeHeaderContent';
import SmallHeaderContent from './SmallHeaderContent';
import {
  AtlassianHeaderLogo,
  AtlassianHeaderLogoImage,
  TextSearchContainer,
  UnwrappedHeader,
  WrappedHeader,
  WrappedLogoMenu,
} from './styles';

import MarketplaceLogo from './images/MarketplaceLogo.svg';

export default class HeaderContent extends Component {
  static propTypes = {
    getUserData: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    userData: ImmutablePropTypes.map.isRequired,
    children: PropTypes.node,
    history: AmktCommonPropTypes.history,
  };

  render() {
    return (
      <ScreenClassRender render={this.screenClassRender}>
        <span />
      </ScreenClassRender>
    );
  }

  screenClassRender = sc => {
    const user = this.props.userData.getIn(['data', '_embedded', 'user']);
    const username = user ? user.get('name') : undefined;
    const userAvatarUrl = user ? user.getIn(['_links', 'picture', 'href']) : undefined;

    const headerTextSearch = <TextSearchContainer>{this.props.children}</TextSearchContainer>;

    const headerLogo = (
      <AtlassianHeaderLogo>
        <Link onClick={this.onClickLogo} title="Atlassian Marketplace" href="/">
          <AtlassianHeaderLogoImage
            src={MarketplaceLogo}
            alt="Atlassian Marketplace"
            id="site-header-logo"
          />
        </Link>
      </AtlassianHeaderLogo>
    );

    const headerMenus =
      sc === 'xs'
        ? this.renderSmallHeader(!!user, username, userAvatarUrl, this.props.userData.get('data'))
        : this.renderFullHeader(!!user, username, userAvatarUrl, this.props.userData.get('data'));

    return ['xs', 'sm'].includes(sc)
      ? this.renderWrappedHeader(headerLogo, headerMenus, headerTextSearch)
      : this.renderUnWrappedHeader(headerLogo, headerMenus, headerTextSearch);
  };

  setWindowLocation = location => {
    window.location = location;
  };

  renderWrappedHeader(headerLogo, headerMenus, headerTextSearch) {
    return (
      <WrappedHeader>
        <WrappedLogoMenu>
          {headerLogo}
          {headerMenus}
        </WrappedLogoMenu>
        {headerTextSearch}
      </WrappedHeader>
    );
  }

  renderUnWrappedHeader(headerLogo, headerMenus, headerTextSearch) {
    return (
      <UnwrappedHeader>
        {headerLogo}
        {headerTextSearch}
        {headerMenus}
      </UnwrappedHeader>
    );
  }

  renderFullHeader(userLoggedIn, username, userAvatarUrl, userData) {
    return (
      <LargeHeaderContent
        onClickLogin={this.onLogin}
        onClickLogout={this.onClickLogout}
        userData={userData}
        userLoggedIn={userLoggedIn}
        username={username}
        userAvatarUrl={userAvatarUrl}
      />
    );
  }

  renderSmallHeader(userLoggedIn, username, userAvatarUrl, userData) {
    return (
      <SmallHeaderContent
        onClickLogin={this.onLogin}
        onClickLogout={this.onClickLogout}
        userAvatarUrl={userAvatarUrl}
        userData={userData}
        username={username}
        userLoggedIn={userLoggedIn}
      />
    );
  }

  onLogin = e => {
    LinkUtils.maybeOpenInNewTab(e, () => {
      if (!this.props.userData.get('loading')) {
        this.setWindowLocation(
          this.props.userData.getIn(['data', '_links', 'login', 'href']) +
            `?redirect=${window.location.pathname}${encodeURIComponent(window.location.search)}`
        );
      }
    });
  };

  onClickLogout = () => {
    this.props.onLogout();
    return true;
  };

  onClickLogo = e => {
    if (this.props.history) {
      LinkUtils.maybeOpenInNewTab(e, () => {
        this.props.history.push({ pathname: '/' });
      });
    }
  };

  componentDidMount() {
    this.props.getUserData();
  }
}
